//routes/index.js
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '../components';
import { useAuth } from '../hooks';
import { WebsiteMonitorProvider } from '../context/WebsiteMonitorContext';

// 公开路由 静态引入
import AuthPage from '../pages/auth';
import Office from '../pages/home/office';
const NewsDetails = lazy(() => import('../pages/home/office/home/NewsDetails'));

// 登录后模块 懒加载
const Personal = lazy(() => import('../pages/home/personal'));
const Profile = lazy(() => import('../pages/profile'));
const MusicModule = lazy(() => import('../pages/home/lifehub/music'));
const AccountingModule = lazy(() => import('../pages/home/lifehub/accounting'));
const WechatModule = lazy(() => import('../pages/home/lifehub/wechat'));
const SportModule = lazy(() => import('../pages/home/lifehub/sport'));
const WorkModule = lazy(() => import('../pages/home/lifehub/work'));
const SystemModule = lazy(() => import('../pages/home/lifehub/system'));
const RecipeModule = lazy(() => import('../pages/home/lifehub/recipe'));


//const CodeCheck = lazy(() => import('../pages/home/office/home/CodeCheck'));
const CodeCheck = lazy(() => import('../pages/home/lifehub/work/pages/CodeCheck'));
const LotterySystem = lazy(() => import('../pages/home/office/home/LotterySystem'));
const QrcodeRealCheck = lazy(() => import('../pages/home/office/home/QrcodeRealCheck'));
const SearchPrice = lazy(() => import('../pages/home/lifehub/work/pages/SearchPrice'));
const LookHousePricePicture = lazy(() => import('../pages/home/lifehub/work/pages/SearchPrice/LookHousePricePicture'));
const Perlerbeads = lazy(() => import('../pages/home/lifehub/game/pages/PerlerBeads'));

// 私有路由守卫
function ProtectedRoute() {
  const { isAuthenticated, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return <Loading message="正在检查登录状态..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

function LazyOutlet() {
  return (
    <Suspense fallback={<Loading message="模块加载中..." />}>
      <Outlet />
    </Suspense>
  );
}

// 根路径重定向 - 根据登录状态
function RootRedirect() {
  const { isAuthenticated, authChecked } = useAuth();

  if (!authChecked) {
    return <Loading message="加载中..." />;
  }

  return <Navigate to={isAuthenticated ? "/wechat" : "/office"} replace />;
}

function AppRoutes() {
  return (
    <WebsiteMonitorProvider>
      <Routes>
        {/* 根路径：根据登录状态自动跳转 */}
        <Route path="/" element={<RootRedirect />} />

        {/* 完全公开页面，未登录也能正常访问 */}
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/office" element={<Office />} />
        <Route path="/newsdetails/:id" element={<NewsDetails />} />

        <Route path="/codeCheck/:code" element={<CodeCheck />} />
        <Route path="/lotterysystem" element={<LotterySystem />} />
        <Route path="/qrcoderealcheck" element={<QrcodeRealCheck />} />
        <Route path="/searchprice" element={<SearchPrice />} />
        <Route path="/LookHousePricePicture" element={<LookHousePricePicture />} />
        <Route path="/perlerbeads" element={<Perlerbeads />} />


        {/* 需要登录才能访问的私有模块 */}
        <Route element={<ProtectedRoute />}>
          <Route element={<LazyOutlet />}>
            <Route path="/personal" element={<Personal />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/music/*" element={<MusicModule />} />
            <Route path="/accounting/*" element={<AccountingModule />} />
            <Route path="/wechat/*" element={<WechatModule />} />
            <Route path="/sport/*" element={<SportModule />} />
            <Route path="/work/*" element={<WorkModule />} />
            <Route path="/system/*" element={<SystemModule />} />

            <Route path="/recipe/*" element={<RecipeModule />} />
          </Route>
        </Route>

        {/* 不存在的路由兜底 */}
        <Route path="*" element={<Navigate to="/office" replace />} />
      </Routes>
    </WebsiteMonitorProvider>
  );
}

export default AppRoutes;